import type { ProductLocalizedText } from '../model/types';

const isLocalizedTextEntry = (v: unknown): v is ProductLocalizedText =>
  typeof v === 'object' &&
  v !== null &&
  'languageCode' in v &&
  'text' in v &&
  typeof (v as { text: unknown }).text === 'string';

// Resolve a product's display title from its localized `title` jsonb (array
// of `{ languageCode, text }`). Prefers the `en` entry, then the first
// available, then the fallback.
export const resolveProductTitle = (title: unknown, fallback = '—'): string => {
  const arr = Array.isArray(title) ? title : [];
  const en = arr.find(
    (t): t is ProductLocalizedText =>
      isLocalizedTextEntry(t) && t.languageCode === 'en'
  );
  if (en?.text) return en.text;
  const first = arr.find(isLocalizedTextEntry);
  return first?.text ?? fallback;
};
